import gsap from 'gsap';

const animations_gsap = {


    // LAYER

    showLayer: function(element, delay){
        gsap.fromTo(`${element}` , {opacity: 0, yPercent: 100, display: "none"}, { duration: 0.7, yPercent: 0, display: "block", opacity: 0.98, delay: delay, ease: 'Circ.out'  })
    },


    hideLayer: function(element, delay){
        gsap.fromTo(`${element}` , {opacity: 1, yPercent: 0, display: "block"}, { duration: 0.7, yPercent: 100, display: "none", opacity: 0, delay: delay, ease: 'Circ.out'  })
    },


    // Steps Wizard

    showStep: function(element, delay, cb){
        gsap.fromTo(`${element}` , {opacity: 0, xPercent: 50, display: "none"}, { duration: 0.7, xPercent: 0, display: "flex", opacity: 0.98, delay: delay, ease: 'Circ.out', onComplete: () => { 
            if(cb){
                cb()
            }
         }})
    },


    hideStep: function(element, delay){
        gsap.fromTo(`${element}` , {opacity: 1, xPercent: 0, display: "flex"}, { duration: 0.7, xPercent: -50, display: "none", opacity: 0, delay: delay, ease: 'Circ.out'  })
    },


    // Steps Wizard Back


    showStepBack: function(element, delay, cb){
        gsap.fromTo(`${element}` , {opacity: 0, xPercent: -50, display: "none"}, { duration: 0.7, xPercent: 0, display: "flex", opacity: 0.98, delay: delay, ease: 'Circ.out', onComplete: () => { 
            if(cb){
                cb()
            }
         }})
    },


    hideStepBack: function(element, delay){
        gsap.fromTo(`${element}` , {opacity: 1, xPercent: 0, display: "flex"}, { duration: 0.7, xPercent: 50, display: "none", opacity: 0, delay: delay, ease: 'Circ.out'  })
    },


    

    // FADES
    fadeOut: function(element, delay, cb){
        gsap.fromTo(`${element}` , {opacity: 1}, { duration: 0.7, opacity: 0, delay: delay, ease: 'Circ.out',onComplete: () => {
            if(cb){
                cb()
            }
        }}) 
    },

    fadeIn: function(element, delay, cb){
        gsap.fromTo(`${element}` , {opacity: 0}, { duration: 0.7, opacity: 1, delay: delay, ease: 'Circ.out',onComplete: () => {
            if(cb){
                cb()
            }
        }}) 
    },


    // SINGLUAR
    showElement: function(element, delay, cb){
        gsap.fromTo(`${element}` , {opacity: 0, y: 60}, { duration: 0.7, opacity: 1, delay: delay, y: 0, ease: 'Circ.out' ,onComplete: () => {
            if(cb){
                // console.log(`Termino Anims`)
                cb()
            } 
        }}) 
    },

    hideElement: function(element, delay, cb){
        gsap.to(`${element}` , { duration: 0.7, delay: delay, opacity: 0, y: 60, ease: 'Circ.out', onComplete: () => {
            if(cb){
                // console.log(`Termino Anims`)
                cb()
            }
        }}) 
    },

    // PLURAL
    showElements: function(element, delay, cb){
        gsap.fromTo(`${element}` , {opacity: 0, y: 20}, { duration: 0.7, opacity: 1,  stagger: 0.2, delay: delay, y: 0, ease: 'Circ.out', onComplete: () => {
            // console.log(`Termino Anims`)
            if(cb){
                cb()
            }
        }}) 
    },
    hideElements: function(element, delay, cb){
        gsap.to(`${element} .anim` , { duration: 0.7, stagger: 0.2, delay: delay, opacity: 0, y: 60, ease: 'Circ.out', onComplete: () => {
            // console.log(`Termino Anims`)
            if(cb){
                cb()
            }
        }})
    },

    // COMBINE
    hideAndShow: function(el1, el2, delay){
        gsap.to(`${el1}` , { duration: 0.7, delay: delay, opacity: 0, y: 60, ease: 'Circ.out', 
        onComplete: () => {
            gsap.fromTo(`${el2}` , {opacity: 0, y: 60}, { duration: 0.7, opacity: 1,  delay: 0.5 , y: 0, ease: 'Circ.out'  }) 
        }});
    },

    // TOOLS CANVAS
    showTool: function(element, delay, cb){
        gsap.fromTo(`${element}` , {opacity: 0, y: 20}, { duration: 0.7, opacity: 1, delay: delay, y: 0, ease: 'Circ.out', onComplete: () => {
            // console.log(`Termino Anims`)
            // cb()
        }})
    },

    showToolResponsive: function(element, delay, cb){
        gsap.fromTo(`${element}` , {opacity: 0, y: 10}, { duration: 0.7, opacity: 1, delay: delay, y: 0, ease: 'Circ.out', onComplete: () => {
            // console.log(`Termino Anims`)
            // cb()
        }})
    },

}


export default animations_gsap;
